// extracted by mini-css-extract-plugin
export default {"root":"MultilineCell_root__mKAdH","placeHolderShimmer":"MultilineCell_placeHolderShimmer__jOMvj"};